const createCustomerAddressCommand = {
  execute: async (context, params, customQuery, customHeaders) => {
    var _a;
    const { data } = await context.app.$vsf.$magento.api.createCustomerAddress(params, customQuery, customHeaders);
    return (_a = data == null ? void 0 : data.createCustomerAddress) != null ? _a : {};
  }
};
export {
  createCustomerAddressCommand
};
